import { ref, toRef, computed, watch, resolveComponent, createBlock, openBlock, resolveDynamicComponent, unref, mergeProps, createSlots, withCtx, renderList, createElementVNode, createVNode, withModifiers, createCommentVNode, normalizeClass, toDisplayString, isRef, withDirectives, createElementBlock, normalizeProps, guardReactiveProps, renderSlot } from "vue";
import { VSelect, VCombobox, VAutocomplete } from "vuetify/components";
import { isFunction, isString, omit, get, isPlainObject, isArray, debounce, set } from "lodash-es";
import "moment";
import { arraysDeepEqualUnordered } from "../../utils/object-utils.js";
import { uuid } from "../../utils/uuid.js";
import { checkRuleExists } from "../../utils/helpers.js";
import { useLocale } from "vuetify";
import { useField } from "vee-validate";
import "../../plugins/apollo.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import { VListItem, VListItemTitle } from "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "./index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import { VProgressLinear } from "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import { VChip } from "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                  */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import { useTheme } from "../../composables/useTheme.js";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                       */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import { Intersect } from "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                      */
import { VTooltip } from "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import { GET_CREATIO_LOOKUP_DATA, GET_LOOKUP_DATA } from "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import { useAutocompleteLoading } from "../../composables/useAutocompleteLoading.js";
import { useLabelOverflow } from "../../composables/useLabelOverflow.js";
import "../../icons/portal/index.js";
const _hoisted_1 = { class: "clear-icon-wrap d-flex justify-center align-center icon--btn" };
const _hoisted_2 = { class: "px-1" };
const _hoisted_3 = { class: "disabled-icon-wrap d-flex justify-center align-center" };
const _sfc_main = /* @__PURE__ */ Object.assign({ inheritAttrs: false }, {
  __name: "BanzaAutoComplete",
  props: {
    modelValue: {},
    name: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: null
    },
    errorMessages: {
      type: [String, Array],
      default: null
    },
    hideDetails: {
      type: [Boolean, String],
      default: "auto"
    },
    variant: {
      type: String,
      default: "outlined"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: null
    },
    itemProps: {
      type: [Boolean, String, Function],
      default: "props"
    },
    itemValue: {
      type: String,
      default: "id"
    },
    itemTitle: {
      type: [String, Function],
      default: "name"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    allowCreateItem: {
      type: Boolean,
      default: false
    },
    query: {
      type: [Object, Function],
      default: null
    },
    queryVariables: {
      type: Object,
      default: () => ({})
    },
    where: {
      type: Object,
      default: () => ({})
    },
    skip: {
      type: Number,
      default: 0
    },
    take: {
      type: Number,
      default: 10
    },
    itemsResultPath: {
      type: String,
      default: "__items"
    },
    pageInfoResultPath: {
      type: String,
      default: "__pageInfo"
    },
    totalCountResultPath: {
      type: String,
      default: "__totalCount"
    },
    searchField: {
      type: String,
      default: null
    },
    searchOperation: {
      type: String,
      default: null
    },
    highlightSearchMatches: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: null
    },
    noSearchText: {
      type: String,
      default: null
    },
    noDataText: {
      type: String,
      default: null
    },
    hideNoData: {
      type: Boolean,
      default: true
    },
    menuProps: {
      type: Object,
      default: () => ({})
    },
    preset: {
      type: String,
      default: ""
    },
    entityName: {
      type: String,
      default: null
    },
    isCreatio: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    menuIcon: {
      type: String,
      default: "mdi-chevron-down"
    }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const input = ref(null);
    const showLabelOverflowTooltip = ref(false);
    const searchText = ref("");
    const selectedLookupItems = ref([]);
    const { t } = useI18n();
    const { t: vt } = useLocale();
    const { hasLabelOverflow } = useLabelOverflow(input);
    const { preset, attrs } = useTheme({
      componentKey: "BanzaAutoComplete",
      presetName: toRef(() => props.preset)
    });
    const isHighlightSearchActive = computed(
      () => {
        var _a;
        return searchText.value && ((_a = attrs.value) == null ? void 0 : _a.highlightSearchMatches) && !props.selectMode;
      }
    );
    const query = computed(
      () => props.query || (props.entityName ? props.isCreatio ? GET_CREATIO_LOOKUP_DATA : GET_LOOKUP_DATA : null)
    );
    const queryVariables = computed(() => {
      var _a;
      return {
        ...props.queryVariables,
        ...props.entityName && !((_a = props.queryVariables) == null ? void 0 : _a.entityName) && {
          entityName: props.entityName
        }
      };
    });
    const isCreatioQuery = computed(() => {
      if (!query.value || isFunction(query.value)) {
        return false;
      }
      const aliases = ["creatio", "baseCreatio"];
      return props.isCreatio || aliases.some(
        (alias) => query.value.definitions[0].selectionSet.selections.some(
          (selection) => selection.name.value === alias
        )
      );
    });
    const searchOperation = computed(
      () => props.searchOperation || (isCreatioQuery.value ? "contains" : "contains_ci")
    );
    const {
      load,
      loadMore,
      loadMissingItems,
      loading,
      items,
      search,
      hasNextPage,
      hasWhere,
      hasSkipTake
    } = useAutocompleteLoading(query, {
      ...props,
      queryVariables
    });
    const isLookupItemSource = computed(() => query.value && !props.returnObject);
    const isPropsItemSource = computed(() => !!props.items);
    const propItems = computed(
      () => {
        var _a;
        return (_a = props.items) == null ? void 0 : _a.map((i) => i.lczKey ? { ...i, name: t(i.lczKey) } : i);
      }
    );
    const sourceItems = computed(
      () => isPropsItemSource.value ? propItems.value : items.value || []
    );
    const innerItems = computed(() => {
      const merged = [...sourceItems.value];
      const existingIds = new Set(merged.map((item) => item[props.itemValue]));
      for (const i of selectedLookupItems.value) {
        const id = i[props.itemValue];
        if (!existingIds.has(id)) {
          merged.push({
            ...i,
            props: {
              __isHidden: true
            }
          });
          existingIds.add(id);
        }
      }
      return merged;
    });
    const searchField = computed(
      () => props.searchField || (isString(props.itemTitle) ? props.itemTitle : "name")
    );
    const noDataText = computed(() => {
      if (loading.value) {
        return props.loadingText || vt("$vuetify.loading");
      }
      if (!searchText.value) {
        return props.noSearchText || t("components.base.autocomplete.no_search_text");
      }
      return props.noDataText || vt("$vuetify.noDataText");
    });
    const itemProps = computed(() => (item) => {
      let result = {};
      const propsGetter = props.itemProps;
      if (propsGetter === true) {
        result = omit(item, ["children"]);
      } else if (isFunction(propsGetter)) {
        result = propsGetter(item);
      } else if (propsGetter) {
        result = get(item, propsGetter);
      }
      if (result == null ? void 0 : result.__isHidden) {
        result = { ...result, class: "d-none" };
      }
      return result;
    });
    const itemTitle = computed(() => {
      const baseFn = isFunction(props.itemTitle) ? props.itemTitle : props.itemTitle ? (item) => isPlainObject(item) ? item == null ? void 0 : item[props.itemTitle] : item : (item) => {
        if (!isPlainObject(item)) return item;
        if (item == null ? void 0 : item.lczKey) return t(item.lczKey);
        return (item == null ? void 0 : item.name) || (item == null ? void 0 : item.id);
      };
      return (item) => {
        if (isArray(item)) return "";
        if (isLookupItemSource.value && !isPlainObject(item)) return "";
        return baseFn(item) ?? "";
      };
    });
    const displayItems = computed(() => {
      const currentItemTitle = itemTitle.value(
        props.multiple ? null : getItem(props.modelValue)
      );
      return searchText.value && searchText.value !== currentItemTitle ? sourceItems.value.filter(
        (item) => itemTitle.value(item).toLowerCase().includes(searchText.value.toLowerCase())
      ) : sourceItems.value;
    });
    const hasOnlyHiddenItems = computed(
      () => displayItems.value.length === 0 && selectedLookupItems.value.length > 0
    );
    const isEmptyValue = (val) => !val || props.multiple && !val.length;
    const getItem = (val) => {
      if (isEmptyValue(val)) {
        return val;
      }
      const compare = (innerItem, modelValue) => (isPlainObject(innerItem) ? innerItem[props.itemValue] : innerItem) === (props.returnObject ? modelValue[props.itemValue] : modelValue);
      return props.multiple ? innerItems.value.filter((i) => !!val.find((v) => compare(i, v))) : innerItems.value.find((i) => compare(i, val));
    };
    const removeItem = (id) => {
      if (isEmptyValue(id)) {
        return;
      }
      const source = isPropsItemSource.value ? props.items : items.value;
      const ids = new Set(Array.isArray(id) ? id : [id]);
      for (let i = source.length - 1; i >= 0; i--) {
        if (ids.has(
          isPlainObject(source[i]) ? source[i][props.itemValue] : source[i]
        )) {
          source.splice(i, 1);
        }
      }
    };
    const onChange = (val) => {
      var _a;
      const onFieldChange = (_a = attrs.value) == null ? void 0 : _a["onUpdate:modelValue"];
      if (isFunction(onFieldChange)) {
        onFieldChange(val);
      } else {
        value.value = val;
      }
    };
    const onSearch = (val) => {
      if (searchText.value === val) {
        return;
      }
      searchText.value = val;
      debouncedSearch();
    };
    const debouncedSearch = debounce(() => {
      if (!hasWhere.value) {
        return;
      }
      const currentItemTitle = itemTitle.value(
        props.multiple ? null : getItem(props.modelValue)
      );
      const searchFilter = searchText.value && searchText.value !== currentItemTitle ? set({}, searchField.value, {
        [searchOperation.value]: searchText.value
      }) : {};
      search(searchFilter);
    }, 300);
    const highlightMatch = (text) => {
      var _a;
      if (!searchText.value || !((_a = attrs.value) == null ? void 0 : _a.highlightSearchMatches)) {
        return text;
      }
      const regex = new RegExp(`(${searchText.value})`, "gi");
      return text.replace(regex, "<strong>$1</strong>");
    };
    const { value, errors, handleBlur, setValue } = useField(
      () => props.name || uuid(),
      toRef(() => props.rules),
      {
        initialValue: isPropsItemSource.value && props.returnObject ? getItem(props.modelValue) : props.modelValue,
        label: props.label
      }
    );
    const isRequired = computed(() => checkRuleExists(props, "required", false));
    const fieldErrors = computed(
      () => props.errorMessages ? [].concat(props.errorMessages) : errors.value || []
    );
    const hideDetails = computed(
      () => props.hideDetails === "auto" ? fieldErrors.value.filter(isString).length === 0 : props.hideDetails
    );
    const onFieldFocused = (focused) => {
      if (focused) {
        showLabelOverflowTooltip.value = false;
        const needPreload = query.value && sourceItems.value.length === 0;
        if (needPreload) {
          load();
        }
      }
    };
    const onFieldBlur = (args) => {
      if (props.multiple) {
        input.value.search = "";
      }
      handleBlur(args);
    };
    const blur = () => {
      input.value.blur();
    };
    const reset = () => {
      input.value.reset();
      input.value.blur();
    };
    const clear = () => {
      var _a;
      const onFieldClear = (_a = attrs.value) == null ? void 0 : _a["onClick:clear"];
      if (isFunction(onFieldClear)) {
        onFieldClear();
      } else {
        if (value.value) {
          onChange(props.multiple ? [] : null);
        } else {
          onSearch("");
        }
      }
      blur();
    };
    const setValueIfNeeded = (val) => {
      const hasChanges = props.multiple ? !arraysDeepEqualUnordered(val, value.value) : JSON.stringify(val) !== JSON.stringify(value.value);
      if (hasChanges) {
        setValue(val);
      }
    };
    watch(
      () => props.modelValue,
      async (newVal) => {
        let item = getItem(newVal);
        let value2 = newVal;
        if (!isEmptyValue(newVal)) {
          if (isLookupItemSource.value) {
            selectedLookupItems.value = await loadMissingItems(
              newVal,
              item
            );
            item = props.multiple ? selectedLookupItems.value : selectedLookupItems.value[0];
            value2 = props.returnObject ? item : newVal;
          } else if (isPropsItemSource.value) {
            value2 = props.returnObject ? item : newVal;
          }
        }
        setValueIfNeeded(value2);
        searchText.value = itemTitle.value(item);
      },
      { immediate: true }
    );
    watch(input, (inputRef) => {
      var _a, _b, _c;
      if (!inputRef) return;
      const menu = (_c = (_b = (_a = inputRef.$) == null ? void 0 : _a.setupState) == null ? void 0 : _b.__v_raw) == null ? void 0 : _c.menu;
      if (!menu || menu.__patched) return;
      const __baseGetter = menu.fn;
      menu.fn = () => {
        if (props.hideNoData && displayItems.value.length === 0) {
          return false;
        }
        return __baseGetter();
      };
      menu.__patched = true;
    });
    __expose({ removeItem, reset, setValue: setValueIfNeeded, blur });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_checkbox = resolveComponent("b-checkbox");
      const _component_b_tooltip = resolveComponent("b-tooltip");
      return openBlock(), createBlock(resolveDynamicComponent(__props.selectMode ? unref(VSelect) : __props.allowCreateItem ? unref(VCombobox) : unref(VAutocomplete)), mergeProps({
        ref_key: "input",
        ref: input,
        "model-value": unref(value),
        label: !__props.hideLabel ? __props.label : null,
        chips: __props.chips,
        items: unref(innerItems),
        "item-title": unref(itemTitle),
        "item-value": __props.itemValue,
        "item-props": unref(itemProps),
        "return-object": __props.returnObject,
        "no-data-text": unref(noDataText),
        search: unref(searchText),
        "no-filter": unref(hasWhere) && unref(hasSkipTake),
        "hide-no-data": __props.hideNoData,
        disabled: __props.disabled,
        clearable: __props.clearable,
        multiple: __props.multiple,
        "error-messages": unref(fieldErrors),
        "hide-details": unref(hideDetails),
        "menu-props": {
          contentClass: "v-autocomplete__content bnz-autocomplete__content",
          stickToTarget: true,
          ...__props.menuProps
        },
        onBlur: onFieldBlur,
        "onUpdate:focused": onFieldFocused,
        "onUpdate:search": onSearch,
        "onUpdate:modelValue": onChange
      }, unref(attrs), {
        "menu-icon": !__props.disabled ? __props.menuIcon : null
      }), createSlots({ _: 2 }, [
        __props.clearable ? {
          name: "clear",
          fn: withCtx(() => {
            var _a, _b, _c, _d;
            return [
              createElementVNode("div", _hoisted_1, [
                createVNode(_component_b_icon, mergeProps({
                  icon: "$b-clear",
                  color: "primary",
                  size: 16
                }, (_d = (_c = (_b = (_a = unref(preset)) == null ? void 0 : _a.slots) == null ? void 0 : _b.clear) == null ? void 0 : _c.icon) == null ? void 0 : _d.attrs, {
                  onClick: withModifiers(clear, ["stop"])
                }), null, 16)
              ])
            ];
          }),
          key: "0"
        } : void 0,
        __props.multiple ? {
          name: "chip",
          fn: withCtx(({ props: props2 }) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i;
            return [
              createVNode(VChip, mergeProps({ color: "primary" }, {
                ...(_d = (_c = (_b = (_a = unref(preset)) == null ? void 0 : _a.slots) == null ? void 0 : _b.chip) == null ? void 0 : _c.chip) == null ? void 0 : _d.attrs,
                ...props2
              }), createSlots({ _: 2 }, [
                ((_i = (_h = (_g = (_f = (_e = unref(preset)) == null ? void 0 : _e.slots) == null ? void 0 : _f.chip) == null ? void 0 : _g.close) == null ? void 0 : _h.icon) == null ? void 0 : _i.attrs) ? {
                  name: "close",
                  fn: withCtx(() => [
                    createVNode(_component_b_icon, mergeProps({
                      icon: "$delete",
                      size: "18"
                    }, unref(preset).slots.chip.close.icon.attrs), null, 16)
                  ]),
                  key: "0"
                } : void 0
              ]), 1040)
            ];
          }),
          key: "1"
        } : void 0,
        __props.multiple ? {
          name: "item",
          fn: withCtx(({ props: props2, item }) => [
            createVNode(VListItem, mergeProps(props2, {
              class: "py-0",
              title: unref(isHighlightSearchActive) ? null : item.title
            }), {
              prepend: withCtx(({ isSelected }) => [
                createVNode(_component_b_checkbox, {
                  class: "mr-1",
                  "model-value": !!isSelected,
                  "hide-details": true,
                  "use-indeterminate-state": false
                }, null, 8, ["model-value"])
              ]),
              default: withCtx(() => [
                unref(isHighlightSearchActive) ? (openBlock(), createBlock(VListItemTitle, {
                  key: 0,
                  innerHTML: highlightMatch(item.title)
                }, null, 8, ["innerHTML"])) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["title"])
          ]),
          key: "2"
        } : unref(isHighlightSearchActive) ? {
          name: "item",
          fn: withCtx(({ props: props2, item }) => [
            createVNode(VListItem, mergeProps(props2, { title: null }), {
              default: withCtx(() => [
                createVNode(VListItemTitle, {
                  innerHTML: highlightMatch(item.title)
                }, null, 8, ["innerHTML"])
              ]),
              _: 2
            }, 1040)
          ]),
          key: "3"
        } : void 0,
        __props.label ? {
          name: "label",
          fn: withCtx(({ label }) => [
            createElementVNode("span", {
              class: normalizeClass({ required: unref(isRequired) })
            }, toDisplayString(label), 3),
            unref(hasLabelOverflow) ? (openBlock(), createBlock(VTooltip, {
              key: 0,
              modelValue: unref(showLabelOverflowTooltip),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(showLabelOverflowTooltip) ? showLabelOverflowTooltip.value = $event : null),
              activator: unref(input),
              "max-width": 300,
              offset: 5,
              text: label
            }, null, 8, ["modelValue", "activator", "text"])) : createCommentVNode("", true)
          ]),
          key: "4"
        } : void 0,
        unref(hasNextPage) ? {
          name: "append-item",
          fn: withCtx(() => [
            withDirectives((openBlock(), createElementBlock("div", null, [
              createElementVNode("div", _hoisted_2, [
                unref(loading) ? (openBlock(), createBlock(VProgressLinear, {
                  key: 0,
                  color: "primary",
                  indeterminate: ""
                })) : createCommentVNode("", true)
              ])
            ])), [
              [
                Intersect,
                (isIntersecting) => {
                  if (isIntersecting) {
                    unref(loadMore)();
                  }
                }
              ]
            ])
          ]),
          key: "5"
        } : void 0,
        __props.disabled ? {
          name: "append-inner",
          fn: withCtx(() => {
            var _a, _b, _c, _d;
            return [
              createElementVNode("div", _hoisted_3, [
                createVNode(_component_b_icon, normalizeProps(guardReactiveProps((_d = (_c = (_b = (_a = unref(preset)) == null ? void 0 : _a.slots) == null ? void 0 : _b.disabled) == null ? void 0 : _c.icon) == null ? void 0 : _d.attrs)), null, 16)
              ])
            ];
          }),
          key: "6"
        } : __props.tooltip ? {
          name: "append-inner",
          fn: withCtx(() => [
            createVNode(_component_b_tooltip, {
              tooltip: __props.tooltip,
              class: "ml-2"
            }, null, 8, ["tooltip"])
          ]),
          key: "7"
        } : void 0,
        unref(hasOnlyHiddenItems) && !__props.hideNoData ? {
          name: "prepend-item",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend-item"),
            renderSlot(_ctx.$slots, "no-data", {}, () => [
              createVNode(VListItem, {
                key: "no-data",
                title: unref(noDataText)
              }, null, 8, ["title"])
            ])
          ]),
          key: "8"
        } : void 0,
        renderList(_ctx.$slots, (_, slotName) => {
          return {
            name: slotName,
            fn: withCtx((slotProps) => [
              renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps || {})))
            ])
          };
        })
      ]), 1040, ["model-value", "label", "chips", "items", "item-title", "item-value", "item-props", "return-object", "no-data-text", "search", "no-filter", "hide-no-data", "disabled", "clearable", "multiple", "error-messages", "hide-details", "menu-props", "menu-icon"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
